'use strict';

/** @type {(() => { name: string, description: string, is_private: boolean, orders: Array<{ orderId: number, count: number }> } | null) | null} */
let draftGetter = null;

/**
 * @param {() => object | null} getter
 */
export function registerStrategyDraftGetter(getter) {
  if (typeof getter !== 'function') {
    throw new Error('registerStrategyDraftGetter: getter must be a function');
  }
  draftGetter = getter;
}

export function unregisterStrategyDraftGetter() {
  draftGetter = null;
}

/**
 * @returns {object | null}
 */
export function getStrategyDraftForInterrupt() {
  if (!draftGetter) {
    return null;
  }
  return draftGetter();
}
